// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import "./JobDetail.css";
// import { getJobDetail } from "../services/jobDetailService";

// /*
//  * Job Detail Page
//  *
//  * Expected usage:
//  *   <JobDetail
//  *      job={selectedJob}
//  *      onBack={() => navigate("/jobs")}
//  *   />
//  *
//  * The component is intentionally UI/data driven. Pass the job object returned
//  * by your existing Jobs API and map only the fields that differ from the
//  * helpers below.
//  */

// const valueOrNA = (value) =>
//   value === undefined || value === null || value === "" ? "N/A" : value;

// const formatDateTime = (value) => {
//   if (!value) return "N/A";

//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return value;

//   return date.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// };

// const formatDate = (value) => {
//   if (!value) return "N/A";

//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return value;

//   return date.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   });
// };

// const getStatusClass = (status) => {
//   const normalized = String(status || "")
//     .trim()
//     .toLowerCase()
//     .replace(/\s+/g, "-");

//   if (["completed", "complete", "success"].includes(normalized)) {
//     return "job-detail-status-completed";
//   }

//   if (["active", "running", "in-progress", "in_progress"].includes(normalized)) {
//     return "job-detail-status-active";
//   }

//   if (["pending", "assigned"].includes(normalized)) {
//     return "job-detail-status-pending";
//   }

//   if (["cancelled", "canceled", "failed"].includes(normalized)) {
//     return "job-detail-status-danger";
//   }

//   return "job-detail-status-default";
// };

// const renderFileLink = (file, label = "View File") => {
//   if (!file) return "N/A";

//   if (typeof file === "string") {
//     return (
//       <a
//         className="job-detail-file-link"
//         href={file}
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         {label}
//       </a>
//     );
//   }

//   const url = file.url || file.file_url || file.path || file.filename;
//   if (!url) return "N/A";

//   return (
//     <a
//       className="job-detail-file-link"
//       href={url}
//       target="_blank"
//       rel="noopener noreferrer"
//     >
//       {file.name || file.filename || label}
//     </a>
//   );
// };

// const InfoRow = ({ label, value, className = "" }) => (
//   <div className={`job-detail-info-row ${className}`}>
//     <div className="job-detail-label">{label}</div>
//     <div className="job-detail-value">{valueOrNA(value)}</div>
//   </div>
// );

// const Section = ({ title, children, className = "" }) => (
//   <section className={`job-detail-section ${className}`}>
//     <div className="job-detail-section-title">{title}</div>
//     <div className="job-detail-section-body">{children}</div>
//   </section>
// );

// function JobDetail({ job: jobProp, onBack: onBackProp }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { jobId: routeJobId } = useParams();

//   const [jobData, setJobData] = useState(null);
//   const [loading, setLoading] = useState(Boolean(routeJobId));
//   const [error, setError] = useState(null);

//   // The URL job ID is the canonical source for the dedicated Job Detail page.
//   // A passed job/state object is kept only as a fallback.
//   useEffect(() => {
//     let cancelled = false;

//     const loadJobDetail = async () => {
//       if (!routeJobId) {
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);
//         setError(null);

//         const data = await getJobDetail(routeJobId);

//         if (!cancelled) {
//           setJobData(data || {});
//         }
//       } catch (err) {
//         console.error("[JOB DETAIL] Failed to load job:", err);

//         if (!cancelled) {
//           setError(
//             err?.message ||
//               "Failed to load job details."
//           );
//           setJobData(null);
//         }
//       } finally {
//         if (!cancelled) {
//           setLoading(false);
//         }
//       }
//     };

//     loadJobDetail();

//     return () => {
//       cancelled = true;
//     };
//   }, [routeJobId]);

//   // API data has priority. Navigation state remains a fallback for
//   // compatibility with any existing usage of this component.
//   const job =
//     jobData ||
//     jobProp ||
//     location.state?.job ||
//     {};

//   const onBack =
//     onBackProp ||
//     (() => navigate("/jobs-management"));

//   /*
//    * These aliases make the component tolerant of common API field names.
//    * If your API uses different names, change these mappings only.
//    */
//   const title = job.title || job.job_title || job.name || "Job Detail";
//   const jobId =
//     job.snap_job_id ||
//     job.snapJobId ||
//     job.job_id ||
//     job.jobId ||
//     job.id ||
//     routeJobId;

//   const status = job.status || job.job_status;

//   const description =
//     job.job_description ||
//     job.description ||
//     job.jobDescription;

//   const voiceNote =
//     job.voice_note ||
//     job.voiceNote ||
//     job.voice_note_url ||
//     job.audio_url;

//   const locationData =
//     job.location_data ||
//     job.locationData ||
//     job.location ||
//     {};

//   const addressNote =
//     job.address_note ||
//     job.addressNote ||
//     job.location_note;

//   const latitude =
//     job.latitude ??
//     job.lat ??
//     locationData.latitude ??
//     locationData.lat;

//   const longitude =
//     job.longitude ??
//     job.lng ??
//     job.lon ??
//     locationData.longitude ??
//     locationData.lng ??
//     locationData.lon;

//   const locationStatus =
//     job.location_status ||
//     job.locationStatus ||
//     (latitude !== undefined && longitude !== undefined
//       ? "Available"
//       : "N/A");

//   const category =
//     job.category_name ||
//     job.category ||
//     job.categoryName;

//   const type = job.type || job.job_type;

//   const price =
//     job.price ??
//     job.budget ??
//     job.job_price;

//   const acceptanceType =
//     job.acceptance_type ||
//     job.acceptanceType;

//   const hours = job.hours ?? job.duration;

//   const allowGallery =
//     job.allow_gallery ??
//     job.allowGallery;

//   const zohoItemId =
//     job.zoho_item_id ||
//     job.zohoItemId;

//   const paymentGateway =
//     job.payment_gateway ||
//     job.paymentGateway;

//   const baseCurrency =
//     job.base_currency ||
//     job.baseCurrency ||
//     job.currency;

//   const budgetNote =
//     job.budget_note ||
//     job.budgetNote;

//   const referenceDescription =
//     job.reference_description ||
//     job.referenceDescription;

//   const ownerName =
//     job.owner_name ||
//     job.ownerName;

//   const ownerEmail =
//     job.owner_email ||
//     job.ownerEmail;

//   const ownerPhone =
//     job.owner_phone ||
//     job.ownerPhone;

//   const ownerId =
//     job.owner_id ||
//     job.ownerId;

//   const applications =
//     job.snapper_applications ||
//     job.snapperApplications ||
//     job.applications ||
//     [];

//   const transactions =
//     job.transactions ||
//     job.transaction_history ||
//     [];

//   const remarks = [
//     ["Remark 1", job.remark_1 ?? job.remark1],
//     ["Remark 2", job.remark_2 ?? job.remark2],
//     ["Remark 3", job.remark_3 ?? job.remark3],
//     ["Remark 4", job.remark_4 ?? job.remark4],
//   ];

//   if (loading) {
//     return (
//       <div className="job-detail-page">
//         <div className="job-detail-header">
//           <div className="job-detail-heading">
//             <button
//               type="button"
//               className="job-detail-back-btn"
//               onClick={onBack}
//               title="Back"
//               aria-label="Back"
//             >
//               ‹
//             </button>
//             <div>
//               <div className="job-detail-title-line">
//                 <h1>Job Detail</h1>
//                 <span className="job-detail-id">
//                   Job ID: {valueOrNA(routeJobId)}
//                 </span>
//               </div>
//               <div className="job-detail-muted">
//                 Loading job details...
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="job-detail-page">
//         <div className="job-detail-header">
//           <div className="job-detail-heading">
//             <button
//               type="button"
//               className="job-detail-back-btn"
//               onClick={onBack}
//               title="Back"
//               aria-label="Back"
//             >
//               ‹
//             </button>
//             <div>
//               <div className="job-detail-title-line">
//                 <h1>Unable to Load Job</h1>
//                 <span className="job-detail-id">
//                   Job ID: {valueOrNA(routeJobId)}
//                 </span>
//               </div>
//               <div className="job-detail-muted">
//                 {error}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="job-detail-page">
//       {/* Page heading */}
//       <div className="job-detail-header">
//         <div className="job-detail-heading">
//           <button
//             type="button"
//             className="job-detail-back-btn"
//             onClick={onBack}
//             title="Back"
//             aria-label="Back"
//           >
//             ‹
//           </button>

//           <div>
//             <div className="job-detail-title-line">
//               <h1>{valueOrNA(title)}</h1>
//               <span className="job-detail-id">
//                 Job ID: {valueOrNA(jobId)}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Basic Information */}
//       <Section title="Basic Information">
//         <div className="job-detail-basic-grid">
//           <InfoRow label="Title" value={title} />
//           <InfoRow label="Snap Job ID" value={jobId} />

//           <div className="job-detail-info-row job-detail-description-row">
//             <div className="job-detail-label">Status</div>
//             <div className="job-detail-value">
//               <span className={`job-detail-status ${getStatusClass(status)}`}>
//                 {valueOrNA(status)}
//               </span>
//             </div>
//           </div>

//           <div className="job-detail-info-row job-detail-description-row">
//             <div className="job-detail-label">Job Description</div>
//             <div className="job-detail-value job-detail-long-text">
//               {valueOrNA(description)}
//             </div>
//           </div>
//         </div>
//       </Section>

//       {/* Voice Note */}
//       <Section title="Voice Note">
//         <div className="job-detail-voice-wrapper">
//           {voiceNote ? (
//             <>
//               <audio className="job-detail-audio" controls src={voiceNote}>
//                 Your browser does not support the audio element.
//               </audio>

//               <div className="job-detail-voice-footer">
//                 <span>{job.voice_note_name || job.audio_name || "Voice Note"}</span>

//                 <a
//                   href={voiceNote}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="job-detail-small-action"
//                 >
//                   Open
//                 </a>
//               </div>
//             </>
//           ) : (
//             <div className="job-detail-muted">N/A</div>
//           )}
//         </div>
//       </Section>

//       {/* Location */}
//       <Section title="Location">
//         <div className="job-detail-location-grid">
//           <InfoRow label="Address Note" value={addressNote} />
//           <InfoRow label="Latitude" value={latitude} />
//           <InfoRow label="Longitude" value={longitude} />
//           <InfoRow
//             label="Location Status"
//             value={
//               String(locationStatus).toLowerCase() === "available" ? (
//                 <span className="job-detail-location-available">
//                   Available
//                 </span>
//               ) : (
//                 locationStatus
//               )
//             }
//           />

//           <div className="job-detail-info-row job-detail-location-data-row">
//             <div className="job-detail-label">Location Data</div>
//             <pre className="job-detail-json">
//               {Object.keys(locationData).length
//                 ? JSON.stringify(locationData, null, 2)
//                 : "N/A"}
//             </pre>
//           </div>
//         </div>
//       </Section>

//       {/* Job Details */}
//       <Section title="Job Details">
//         <div className="job-detail-job-grid">
//           <InfoRow label="Category" value={category} />
//           <InfoRow label="Type" value={type} />
//           <InfoRow label="Price" value={price} />
//           <InfoRow label="Acceptance Type" value={acceptanceType} />
//           <InfoRow label="Hours" value={hours} />
//           <InfoRow
//             label="Payment Gateway"
//             value={paymentGateway}
//           />
//           <InfoRow
//             label="Allow Gallery"
//             value={
//               allowGallery === undefined ||
//               allowGallery === null ||
//               allowGallery === ""
//                 ? "N/A"
//                 : String(allowGallery).toUpperCase()
//             }
//           />
//           <InfoRow label="Zoho Item ID" value={zohoItemId} />
//           <InfoRow label="Base Currency" value={baseCurrency} />
//           <InfoRow label="Budget Note" value={budgetNote} />
//           <InfoRow
//             label="Reference Description"
//             value={referenceDescription}
//           />

//           {remarks.map(([label, value]) => (
//             <InfoRow key={label} label={label} value={value} />
//           ))}
//         </div>
//       </Section>

//       {/* Owner Information */}
//       <Section title="Owner Information">
//         <div className="job-detail-owner-grid">
//           <InfoRow label="Owner Name" value={ownerName} />
//           <InfoRow label="Owner Email" value={ownerEmail} />
//           <InfoRow label="Owner Phone" value={ownerPhone} />
//           <InfoRow label="Owner ID" value={ownerId} />
//         </div>
//       </Section>

//       {/* Snapper's Applications */}
//       <Section title="Snapper's Applications">
//         {applications.length ? (
//           <div className="job-detail-table-wrapper">
//             <table className="job-detail-table">
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>SNAPPER PHONE</th>
//                   <th>SNAPPER NAME</th>
//                   <th>APPLIED TIME</th>
//                   <th>STATUS</th>
//                   <th>ACTIONS</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {applications.map((application, index) => {
//                   const applicationStatus =
//                     application.status || application.application_status;

//                   return (
//                     <tr
//                       key={
//                         application.id ||
//                         application.application_id ||
//                         index
//                       }
//                     >
//                       <td>
//                         {valueOrNA(
//                           application.id || application.application_id
//                         )}
//                       </td>
//                       <td>
//                         {valueOrNA(
//                           application.snapper_phone ||
//                             application.phone ||
//                             application.snapperPhone
//                         )}
//                       </td>
//                       <td className="job-detail-name-cell">
//                         {valueOrNA(
//                           application.snapper_name ||
//                             application.name ||
//                             application.snapperName
//                         )}
//                       </td>
//                       <td>
//                         {formatDateTime(
//                           application.applied_time ||
//                             application.applied_at ||
//                             application.created_at
//                         )}
//                       </td>
//                       <td>
//                         <span
//                           className={`job-detail-status ${getStatusClass(
//                             applicationStatus
//                           )}`}
//                         >
//                           {valueOrNA(applicationStatus)}
//                         </span>
//                       </td>
//                       <td>
//                         {application.view_url || application.url ? (
//                           <a
//                             className="job-detail-view-btn"
//                             href={application.view_url || application.url}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           <button
//                             type="button"
//                             className="job-detail-view-btn"
//                             onClick={() =>
//                               console.log(
//                                 "Application selected:",
//                                 application
//                               )
//                             }
//                           >
//                             View
//                           </button>
//                         )}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div className="job-detail-table-empty">
//             No snapper applications found.
//           </div>
//         )}
//       </Section>

//       {/* Transactions */}
//       <Section title="Transactions">
//         {transactions.length ? (
//           <div className="job-detail-table-wrapper">
//             <table className="job-detail-table">
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>NAME</th>
//                   <th>ACTION</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {transactions.map((transaction, index) => (
//                   <tr
//                     key={
//                       transaction.id ||
//                       transaction.transaction_id ||
//                       index
//                     }
//                   >
//                     <td>
//                       {valueOrNA(
//                         transaction.id || transaction.transaction_id
//                       )}
//                     </td>
//                     <td>
//                       {valueOrNA(
//                         transaction.name ||
//                           transaction.description ||
//                           transaction.transaction_name
//                       )}
//                     </td>
//                     <td>
//                       {transaction.view_url || transaction.url ? (
//                         <a
//                           className="job-detail-view-btn"
//                           href={transaction.view_url || transaction.url}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           View
//                         </a>
//                       ) : (
//                         <button
//                           type="button"
//                           className="job-detail-view-btn"
//                           onClick={() =>
//                             console.log(
//                               "Transaction selected:",
//                               transaction
//                             )
//                           }
//                         >
//                           View
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div className="job-detail-table-empty">
//             No transactions found.
//           </div>
//         )}
//       </Section>

//       {/* Optional files / metadata */}
//       {(job.reference_file ||
//         job.ref_file ||
//         job.job_detail_file ||
//         job.created_at ||
//         job.updated_at) && (
//         <Section title="Additional Information">
//           <div className="job-detail-owner-grid">
//             <InfoRow
//               label="Reference File"
//               value={renderFileLink(
//                 job.reference_file || job.ref_file,
//                 "View File"
//               )}
//             />
//             <InfoRow
//               label="Job Detail File"
//               value={renderFileLink(
//                 job.job_detail_file,
//                 "View File"
//               )}
//             />
//             <InfoRow
//               label="Created At"
//               value={formatDateTime(job.created_at)}
//             />
//             <InfoRow
//               label="Updated At"
//               value={formatDateTime(job.updated_at)}
//             />
//           </div>
//         </Section>
//       )}
//     </div>
//   );
// }

// export default JobDetail;

import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./JobDetail.css";
import { getJobDetail } from "../services/jobDetailService";

/*
 * Job Detail Page
 *
 * Expected usage:
 *   <JobDetail job={selectedJob} />
 *
 * The component is intentionally UI/data driven. Pass the job object returned
 * by your existing Jobs API and map only the fields that differ from the
 * helpers below.
 */

const valueOrNA = (value) =>
  value === undefined || value === null || value === "" ? "N/A" : value;

const formatDateTime = (value) => {
  if (!value) return "N/A";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatDate = (value) => {
  if (!value) return "N/A";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const getStatusClass = (status) => {
  const normalized = String(status || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

  if (["completed", "complete", "success"].includes(normalized)) {
    return "job-detail-status-completed";
  }

  if (["active", "running", "in-progress", "in_progress"].includes(normalized)) {
    return "job-detail-status-active";
  }

  if (["pending", "assigned"].includes(normalized)) {
    return "job-detail-status-pending";
  }

  if (["cancelled", "canceled", "failed"].includes(normalized)) {
    return "job-detail-status-danger";
  }

  return "job-detail-status-default";
};

const renderFileLink = (file, label = "View File") => {
  if (!file) return "N/A";

  if (typeof file === "string") {
    return (
      <a
        className="job-detail-file-link"
        href={file}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>
    );
  }

  const url = file.url || file.file_url || file.path || file.filename;
  if (!url) return "N/A";

  return (
    <a
      className="job-detail-file-link"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {file.name || file.filename || label}
    </a>
  );
};

const InfoRow = ({ label, value, className = "" }) => (
  <div className={`job-detail-info-row ${className}`}>
    <div className="job-detail-label">{label}</div>
    <div className="job-detail-value">{valueOrNA(value)}</div>
  </div>
);

const Section = ({ title, children, className = "" }) => (
  <section className={`job-detail-section ${className}`}>
    <div className="job-detail-section-title">{title}</div>
    <div className="job-detail-section-body">{children}</div>
  </section>
);

function JobDetail({ job: jobProp }) {
  const location = useLocation();
  const { jobId: routeJobId } = useParams();

  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(Boolean(routeJobId));
  const [error, setError] = useState(null);

  // The URL job ID is the canonical source for the dedicated Job Detail page.
  // A passed job/state object is kept only as a fallback.
  useEffect(() => {
    let cancelled = false;

    const loadJobDetail = async () => {
      if (!routeJobId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const data = await getJobDetail(routeJobId);

        if (!cancelled) {
          setJobData(data || {});
        }
      } catch (err) {
        console.error("[JOB DETAIL] Failed to load job:", err);

        if (!cancelled) {
          setError(
            err?.message ||
              "Failed to load job details."
          );
          setJobData(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadJobDetail();

    return () => {
      cancelled = true;
    };
  }, [routeJobId]);

  // API data has priority. Navigation state remains a fallback for
  // compatibility with any existing usage of this component.
  const job =
    jobData ||
    jobProp ||
    location.state?.job ||
    {};

  /*
   * These aliases make the component tolerant of common API field names.
   * If your API uses different names, change these mappings only.
   */
  const title = job.title || job.job_title || job.name || "Job Detail";
  const jobId =
    job.snap_job_id ||
    job.snapJobId ||
    job.job_id ||
    job.jobId ||
    job.id ||
    routeJobId;

  const status = job.status || job.job_status;

  const description =
    job.job_description ||
    job.description ||
    job.jobDescription;

  const voiceNote =
    job.voice_note ||
    job.voiceNote ||
    job.voice_note_url ||
    job.audio_url;

  const locationData =
    job.location_data ||
    job.locationData ||
    job.location ||
    {};

  const addressNote =
    job.address_note ||
    job.addressNote ||
    job.location_note;

  const latitude =
    job.latitude ??
    job.lat ??
    locationData.latitude ??
    locationData.lat;

  const longitude =
    job.longitude ??
    job.lng ??
    job.lon ??
    locationData.longitude ??
    locationData.lng ??
    locationData.lon;

  const locationStatus =
    job.location_status ||
    job.locationStatus ||
    (latitude !== undefined && longitude !== undefined
      ? "Available"
      : "N/A");

  const category =
    job.category_name ||
    job.category ||
    job.categoryName;

  const type = job.type || job.job_type;

  const price =
    job.price ??
    job.budget ??
    job.job_price;

  const acceptanceType =
    job.acceptance_type ||
    job.acceptanceType;

  const hours = job.hours ?? job.duration;

  const allowGallery =
    job.allow_gallery ??
    job.allowGallery;

  const zohoItemId =
    job.zoho_item_id ||
    job.zohoItemId;

  const paymentGateway =
    job.payment_gateway ||
    job.paymentGateway;

  const baseCurrency =
    job.base_currency ||
    job.baseCurrency ||
    job.currency;

  const budgetNote =
    job.budget_note ||
    job.budgetNote;

  const referenceDescription =
    job.reference_description ||
    job.referenceDescription;

  const ownerName =
    job.owner_name ||
    job.ownerName;

  const ownerEmail =
    job.owner_email ||
    job.ownerEmail;

  const ownerPhone =
    job.owner_phone ||
    job.ownerPhone;

  const ownerId =
    job.owner_id ||
    job.ownerId;

  const applications =
    job.snapper_applications ||
    job.snapperApplications ||
    job.applications ||
    [];

  const transactions =
    job.transactions ||
    job.transaction_history ||
    [];

  const remarks = [
    ["Remark 1", job.remark_1 ?? job.remark1],
    ["Remark 2", job.remark_2 ?? job.remark2],
    ["Remark 3", job.remark_3 ?? job.remark3],
    ["Remark 4", job.remark_4 ?? job.remark4],
  ];

  if (loading) {
    return (
      <div className="job-detail-page">
        <div className="job-detail-header">
          <div className="job-detail-heading">
            <div>
              <div className="job-detail-title-line">
                <h1>Job Detail</h1>
                <span className="job-detail-id">
                  Job ID: {valueOrNA(routeJobId)}
                </span>
              </div>
              <div className="job-detail-muted">
                Loading job details...
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="job-detail-page">
        <div className="job-detail-header">
          <div className="job-detail-heading">
            <div>
              <div className="job-detail-title-line">
                <h1>Unable to Load Job</h1>
                <span className="job-detail-id">
                  Job ID: {valueOrNA(routeJobId)}
                </span>
              </div>
              <div className="job-detail-muted">
                {error}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="job-detail-page">
      {/* Page heading */}
      <div className="job-detail-header">
        <div className="job-detail-heading">
          <div>
            <div className="job-detail-title-line">
              <h1>{valueOrNA(title)}</h1>
              <span className="job-detail-id">
                Job ID: {valueOrNA(jobId)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Basic Information */}
      <Section title="Basic Information">
        <div className="job-detail-basic-grid">
          <InfoRow label="Title" value={title} />
          <InfoRow label="Snap Job ID" value={jobId} />

          <div className="job-detail-info-row job-detail-description-row">
            <div className="job-detail-label">Status</div>
            <div className="job-detail-value">
              <span className={`job-detail-status ${getStatusClass(status)}`}>
                {valueOrNA(status)}
              </span>
            </div>
          </div>

          <div className="job-detail-info-row job-detail-description-row">
            <div className="job-detail-label">Job Description</div>
            <div className="job-detail-value job-detail-long-text">
              {valueOrNA(description)}
            </div>
          </div>
        </div>
      </Section>

      {/* Voice Note */}
      <Section title="Voice Note">
        <div className="job-detail-voice-wrapper">
          {voiceNote ? (
            <>
              <audio className="job-detail-audio" controls src={voiceNote}>
                Your browser does not support the audio element.
              </audio>

              <div className="job-detail-voice-footer">
                <span>{job.voice_note_name || job.audio_name || "Voice Note"}</span>

                <a
                  href={voiceNote}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="job-detail-small-action"
                >
                  Open
                </a>
              </div>
            </>
          ) : (
            <div className="job-detail-muted">N/A</div>
          )}
        </div>
      </Section>

      {/* Location */}
      <Section title="Location">
        <div className="job-detail-location-grid">
          <InfoRow label="Address Note" value={addressNote} />
          <InfoRow label="Latitude" value={latitude} />
          <InfoRow label="Longitude" value={longitude} />
          <InfoRow
            label="Location Status"
            value={
              String(locationStatus).toLowerCase() === "available" ? (
                <span className="job-detail-location-available">
                  Available
                </span>
              ) : (
                locationStatus
              )
            }
          />

          <div className="job-detail-info-row job-detail-location-data-row">
            <div className="job-detail-label">Location Data</div>
            <pre className="job-detail-json">
              {Object.keys(locationData).length
                ? JSON.stringify(locationData, null, 2)
                : "N/A"}
            </pre>
          </div>
        </div>
      </Section>

      {/* Job Details */}
      <Section title="Job Details">
        <div className="job-detail-job-grid">
          <InfoRow label="Category" value={category} />
          <InfoRow label="Type" value={type} />
          <InfoRow label="Price" value={price} />
          <InfoRow label="Acceptance Type" value={acceptanceType} />
          <InfoRow label="Hours" value={hours} />
          <InfoRow
            label="Payment Gateway"
            value={paymentGateway}
          />
          <InfoRow
            label="Allow Gallery"
            value={
              allowGallery === undefined ||
              allowGallery === null ||
              allowGallery === ""
                ? "N/A"
                : String(allowGallery).toUpperCase()
            }
          />
          <InfoRow label="Zoho Item ID" value={zohoItemId} />
          <InfoRow label="Base Currency" value={baseCurrency} />
          <InfoRow label="Budget Note" value={budgetNote} />
          <InfoRow
            label="Reference Description"
            value={referenceDescription}
          />

          {remarks.map(([label, value]) => (
            <InfoRow key={label} label={label} value={value} />
          ))}
        </div>
      </Section>

      {/* Owner Information */}
      <Section title="Owner Information">
        <div className="job-detail-owner-grid">
          <InfoRow label="Owner Name" value={ownerName} />
          <InfoRow label="Owner Email" value={ownerEmail} />
          <InfoRow label="Owner Phone" value={ownerPhone} />
          <InfoRow label="Owner ID" value={ownerId} />
        </div>
      </Section>

      {/* Snapper's Applications */}
      <Section title="Snapper's Applications">
        {applications.length ? (
          <div className="job-detail-table-wrapper">
            <table className="job-detail-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>SNAPPER PHONE</th>
                  <th>SNAPPER NAME</th>
                  <th>APPLIED TIME</th>
                  <th>STATUS</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((application, index) => {
                  const applicationStatus =
                    application.status || application.application_status;

                  return (
                    <tr
                      key={
                        application.id ||
                        application.application_id ||
                        index
                      }
                    >
                      <td>
                        {valueOrNA(
                          application.id || application.application_id
                        )}
                      </td>
                      <td>
                        {valueOrNA(
                          application.snapper_phone ||
                            application.phone ||
                            application.snapperPhone
                        )}
                      </td>
                      <td className="job-detail-name-cell">
                        {valueOrNA(
                          application.snapper_name ||
                            application.name ||
                            application.snapperName
                        )}
                      </td>
                      <td>
                        {formatDateTime(
                          application.applied_time ||
                            application.applied_at ||
                            application.created_at
                        )}
                      </td>
                      <td>
                        <span
                          className={`job-detail-status ${getStatusClass(
                            applicationStatus
                          )}`}
                        >
                          {valueOrNA(applicationStatus)}
                        </span>
                      </td>
                      <td>
                        {application.view_url || application.url ? (
                          <a
                            className="job-detail-view-btn"
                            href={application.view_url || application.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          <button
                            type="button"
                            className="job-detail-view-btn"
                            onClick={() =>
                              console.log(
                                "Application selected:",
                                application
                              )
                            }
                          >
                            View
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="job-detail-table-empty">
            No snapper applications found.
          </div>
        )}
      </Section>

      {/* Transactions */}
      <Section title="Transactions">
        {transactions.length ? (
          <div className="job-detail-table-wrapper">
            <table className="job-detail-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>NAME</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction, index) => (
                  <tr
                    key={
                      transaction.id ||
                      transaction.transaction_id ||
                      index
                    }
                  >
                    <td>
                      {valueOrNA(
                        transaction.id || transaction.transaction_id
                      )}
                    </td>
                    <td>
                      {valueOrNA(
                        transaction.name ||
                          transaction.description ||
                          transaction.transaction_name
                      )}
                    </td>
                    <td>
                      {transaction.view_url || transaction.url ? (
                        <a
                          className="job-detail-view-btn"
                          href={transaction.view_url || transaction.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      ) : (
                        <button
                          type="button"
                          className="job-detail-view-btn"
                          onClick={() =>
                            console.log(
                              "Transaction selected:",
                              transaction
                            )
                          }
                        >
                          View
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="job-detail-table-empty">
            No transactions found.
          </div>
        )}
      </Section>

      {/* Optional files / metadata */}
      {(job.reference_file ||
        job.ref_file ||
        job.job_detail_file ||
        job.created_at ||
        job.updated_at) && (
        <Section title="Additional Information">
          <div className="job-detail-owner-grid">
            <InfoRow
              label="Reference File"
              value={renderFileLink(
                job.reference_file || job.ref_file,
                "View File"
              )}
            />
            <InfoRow
              label="Job Detail File"
              value={renderFileLink(
                job.job_detail_file,
                "View File"
              )}
            />
            <InfoRow
              label="Created At"
              value={formatDateTime(job.created_at)}
            />
            <InfoRow
              label="Updated At"
              value={formatDateTime(job.updated_at)}
            />
          </div>
        </Section>
      )}
    </div>
  );
}

export default JobDetail;